'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /~/react/react.js
// module id = U7vG
// module chunks = 0